<template>
    <Loading v-model:active="isLoading" :can-cancel="false" :is-full-page=false />
    <section class="gradient-custom">
        <div class="container my-5">
            <img v-bind:src="require('@/assets/logo_dark.png')" alt="Responsive image" style="width: 200px;">
            <div class="row d-flex justify-content-center py-4">
                <div class="col-md-7 col-lg-5 col-xl-8">
                    <div class="card" style="border-radius: 15px;">
                        <div class="card-body">
                            <h5 class="card-title">Comprar Suscripción</h5>
                            <h6 align="left" class="card-title" siez="17" aria-label="Default"
                                aria-describedby="inputGroup-sizing-default">Apodo</h6>
                            <p id="typeName" class="form-control form-control-lg" siez="17" aria-label="Default"
                                aria-describedby="inputGroup-sizing-default" align="left">{{ user }}</p>
                            <br>
                            <p for="disabledSelect" class="form-label" align="left">Elige una suscripción y disfruta de
                                la verdadera privacidad</p>
                            <select class="form-select form-control form-control-lg" siez="17"
                                aria-label="Default select example" aria-describedby="inputGroup-sizing-default"
                                v-model="select" @change="totalAmount" placeholder="Cargando Datos...">
                                <option v-for="subcrip in subscribed" v-bind:key="subcrip.id" :value="subcrip.id">
                                    {{ subcrip.description }}
                                </option>
                            </select>
                            <br>
                            <p for="disabledSelect" class="form-label" align="left">Eres referido? Ingresa el código que
                                te compartieron</p>
                            <input type="text" id="typeName" :maxlength="max" class="form-control form-control-lg"
                                siez="17" aria-label="Default" aria-describedby="inputGroup-sizing-default"
                                v-model="referido">
                            <br>
                            <h5 align="left">Total a pagar: {{ amount }} {{ contry }}</h5>
                            <p align="left">¡Obtén Cashback al Suscribirte! &nbsp; Suscripción mensual, ganas $0.50 USD.
                                &nbsp; Suscripción anual, ganas $1.00 USD.</p>
                            <p align="left">*Al presionar el botón pagar, usted está aceptando los
                                <a href="https://napoleon.chat/terminos-condiciones" target=“_blank”
                                    style="color:#d7a952;">términos y condiciones </a>
                            </p>
                            <div
                                class="col-md-12 d-flex flex-column flex-md-row justify-content-center align-items-center">
                                <button type="button" class="btn btn-outline-success mb-2 mb-md-0 mx-2"
                                    v-on:click="usdt">USDT</button>
                                <button type="button" class="btn btn-outline-warning mb-2 mb-md-0 mx-2"
                                    v-on:click="paySubcrip">Otros medios de Pago</button>
                                <a href="https://napoleon.chat/" type="button"
                                    class="btn btn-outline-dark mx-2">Cancelar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import axios from 'axios';
import consta from "../globals/constUrl.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import HttpsUtils from "../Utlis/HttpsUtils"
import { IpregistryClient } from '@ipregistry/client';

export default {
    name: "UnsubscribedComponent",
    data() {
        return {
            amount: 0,
            subscribed: [],
            user: "",
            select: 19,//id de subcripcion
            idSub: 0,
            referido: null,
            max: 20,
            values: [],
            contry: "",
            tasa: 0.0,
            isLoading: false,
            isUsdt: false,
        }
    },
    mounted() {
        this.consultUser()
        this.consultPrice()
        this.totalAmount()
    },
    methods: {
        totalAmount() {
            if (this.subscribed) {
                this.subscribed.forEach(element => {
                    if (element.id == this.select) {
                        this.amount = element.price
                    }
                });
            }
        },

        async consultUser() {
            let data = await new HttpsUtils().get('v2/public/user/' + this.$route.params.id)
            this.user = data.data.nick
        },

        async consultPrice() {
            this.isLoading = true
            let data = await new HttpsUtils().get('v3/public/subscription')
            this.values = data.data
            this.getCountry()
        },

        getCountry() {
            fetch('https://api.ipify.org?format=json')
                .then(response => response.json())
                .then(data => {
                    this.getCountryIp(data.ip)
                })
                .catch(() => {
                    this.contry = "USD"
                    this.valid()
                });
        },

        getCountryIp(ip) {
            const client = new IpregistryClient('65gy7qlropqgkdop');
            client.lookupIp(ip).then(response => {
                this.contry = response.data.currency.code
                this.valid(response.data.location.country.code)
            }).catch(() => {
                this.contry = "USD"
                this.valid()
            })
        },

        async valid() {
            let datanew = await new HttpsUtils().getOther('https://openexchangerates.org/api/latest.json?app_id=77ffd9d1f2b84c2798dcfbe0eaf69126')
            let money = datanew.rates
            for (const cod in money) {
                let tasa = money[cod]
                if (this.contry == cod) {
                    this.chargeMoney(tasa)
                    break
                }
            }
        },

        chargeMoney(money) {
            this.values.forEach(item => {
                let info = {}
                let value = parseFloat(item.price)
                let total = value * money
                let format = total.toLocaleString();
                if (item.id == 7) {
                    info = {
                        id: item.id,
                        description: "Anual " + format + " " + this.contry + " (Ahorra 53%)",
                        price: format
                    }
                    this.subscribed.push(info)
                } else if (item.id == 19) {
                    this.amount = format
                    info = {
                        id: item.id,
                        description: "Mensual " + format + " " + this.contry,
                        price: format
                    }
                    this.subscribed.push(info)
                }
            })
            this.isLoading = false
        },

        usdt() {
            this.isUsdt = true
            this.paySubcrip()
        },

        paySubcrip() {
            this.isLoading = true
            let ctx = this;
            let data = {
                "user_id": ctx.$route.params.id,
                "sublan_id": ctx.select,
                "referrer_code": ctx.referido,
                "is_usdt": this.isUsdt
            };
            if (ctx.select != 0) {
                axios.post(consta.serverSrc + 'v3/public/payment', data, { headers: { 'Content-Type': 'application/json', 'language-iso': 'es', 'token': consta.token }, data: {} })
                    .then(function (response) {
                        if (ctx.referido != null) {
                            ctx.$swal({
                                title: 'Satisfactorio',
                                icon: 'success',
                                text: response.data.data.referResponse,
                                showCloseButton: true,
                                confirmButtonColor: '#d7a952'
                            })
                        }
                        ctx.isUsdt = false
                        if (!response.data.data.usdt) {
                            ctx.redirectPayment(response.data.data[0])
                        } else {
                            ctx.redirectUsdt(response.data.data[0])
                        }
                    }).catch(error => {
                        ctx.isLoading = false
                        if (error.response.data.error) {
                            ctx.$swal({
                                title: 'Error',
                                icon: 'error',
                                text: error.response.data.error.message,
                                showCloseButton: true,
                                confirmButtonColor: '#d7a952'
                            })
                        }
                        if (ctx.referido != null) {
                            if (error.response.status == 422) {
                                ctx.$swal({
                                    title: 'Error',
                                    icon: 'error',
                                    text: "El código de referido no debe ser mayor a 20 caracteres.",
                                    showCloseButton: true,
                                    confirmButtonColor: '#d7a952'
                                })
                            } else {
                                ctx.$swal({
                                    title: 'Error',
                                    icon: 'error',
                                    text: error.response.data.error.message,
                                    showCloseButton: true,
                                    confirmButtonColor: '#d7a952'
                                })
                            }
                        } else if (ctx.referido == null) {
                            ctx.$swal({
                                title: 'Error',
                                icon: 'error',
                                text: error.response.data.error.message,
                                showCloseButton: true,
                                confirmButtonColor: '#d7a952'
                            })
                        }
                    })
            } else {
                ctx.$swal({
                    title: 'Error',
                    icon: 'error',
                    text: 'Por favor seleccione un tipo de suscripción',
                    showCloseButton: true,
                    confirmButtonColor: '#d7a952'
                })
            }
        },

        redirectPayment(data) {
            this.isLoading = false
            let orden = data.pay_reference
            let amount = data.subscriptions_languages.sublan_price
            let code = data.code
            let userId = data.user_id
            this.$router.push({ name: 'pasarela', params: { orden: orden, amount: amount, code: code, user: userId } })
        },

        async redirectUsdt(data) {
            let ctx = this
            let request = {
                "price_amount": parseInt(data.subscriptions_languages.sublan_price) + 1.3,
                "price_currency": "usd",
                "order_id": data.pay_reference,
                "order_description": "Pago suscripción NapoleoN Chat",
                "ipn_callback_url": `https://payments.napoleon-chat.com/#/${this.$route.params.id}`,
                "success_url": `https://payments.napoleon-chat.com/#/${this.$route.params.id}`,
                "cancel_url": `https://payments.napoleon-chat.com/#/${this.$route.params.id}`
            }
            await axios.post('https://api.nowpayments.io/v1/invoice', request, { headers: { 'Content-Type': 'application/json', 'x-api-key': '1QKYTV1-3DFMWGK-KQJ1BXZ-TJ7E8PT' } })// cambiar x-api-key de produccion
                .then(function (response) {
                    ctx.savePaymentId(data.pay_id, response.data.id)
                    ctx.isLoading = false
                    window.location.href = response.data.invoice_url
                }).catch(error => {
                    console.log(error);
                })
        },
        async savePaymentId(payment, referId) {
            let data = {
                "payment_id": payment,
                "refer_id": referId
            }
            await new HttpsUtils().post('v3/public/payment/update', data)
        }
    },
    components: {
        Loading
    }
}
</script>